import React from "react";
import { Avatar } from "ui-components";
import { randomNumber, gotoUrl, urlParam } from "utils/helpers";
import { CALL_BACK_URL } from "utils/constants";
import { useLocation } from "react-router-dom";
import {
  setItem,
  SOCIAL_MEDIA_STATE,
  APP_REDIRECT_PATH
} from "utils/localStorage";

const FacebookIcon = ({
  iconUrl,
  socialLoginUrl: fabebookAuthUrl,
  channelId,
  overrideParams = {}
}) => {
  const { pathname } = useLocation();
  const scope = "email,public_profile";
  const redirect = urlParam("redirect");

  /**
   * OverrideParams can be used to override default values or to inject any
   * additional params.It is coming from generic.social_media_signin_options
   */
  const onClickEvent = () => {
    const path = pathname.replace(/\//g, "z");
    const state = `${randomNumber()}${path}`;
    const urlParams = {
      response_type: "code",
      client_id: channelId,
      redirect_uri: CALL_BACK_URL.FACEBOOK,
      scope: scope,
      state: state,
      ...overrideParams
    };
    if (fabebookAuthUrl) {
      setItem(SOCIAL_MEDIA_STATE, state);
      // Sets redirect url to redirect after loggin
      redirect && setItem(APP_REDIRECT_PATH, redirect);
      gotoUrl(fabebookAuthUrl, false, {}, false, urlParams);
    }
  };

  return (
    <Avatar
      src={iconUrl}
      onClick={onClickEvent}
      data-testid="facebook-icon"
      style={{ cursor: "pointer" }}
    />
  );
};
export default FacebookIcon;
